import React from "react";
import { FaPenToSquare } from "react-icons/fa6";
import { AiFillDelete } from "react-icons/ai";

const CategoryTable: React.FC<any> = ({
  columns,
  data,
  columnsKeys,
  onEdit,
  onDelete,
}) => {
  return (
    <div className="mt-4">
      <div className="relative overflow-x-auto max-h-[85vh] hide-scrollbar shadow-sm overflow-auto  sm:rounded-lg">
        <table className="w-full text-sm text-left  text-gray-500 font-poppins">
          <thead className="text-xs text-white sticky top-0 uppercase  bg-gray-700 ">
            <tr>
              {columns &&
                columns.map((column: any) => (
                  <th key={column} scope="col" className="px-6 py-3">
                    {column}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody className="overflow-y-auto">
            {data &&
              data.map((item: any) => (
                <tr key={item.id} className="odd:bg-white border-b">
                  <td className="px-6 ">
                    <img
                      src={item[columnsKeys[0]]}
                      className="w-10 h-10 rounded-md"
                    />
                  </td>
                  <th
                    scope="row"
                    className="px-6 py-4 max-w-[15rem] overflow-hidden text-ellipsis font-medium text-gray-900 whitespace-nowrap "
                  >
                    {item[columnsKeys[1]]}
                  </th>
                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    {item[columnsKeys[2]]}
                  </td>
                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    {item.products.length}
                  </td>

                  <td className="px-6 py-4">
                    <div className="flex gap-4 items-center justify-center">
                      <div
                        onClick={() => onEdit(item)}
                        className="cursor-pointer bg-slate-200 rounded-full p-2"
                      >
                        <FaPenToSquare />
                      </div>
                      <div
                        onClick={() => onDelete(item)}
                        className="cursor-pointer bg-slate-200 rounded-full p-2"
                      >
                        <AiFillDelete />
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CategoryTable;
